import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 19 19",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: color,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-0.500000, 0.000000)",
    fill: color
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "9",
    y: "0",
    width: "2",
    height: "5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: "9",
    y: "14",
    width: "2",
    height: "5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(17.000000, 9.500000) rotate(-270.000000) translate(-17.000000, -9.500000) ",
    x: "16",
    y: "7",
    width: "2",
    height: "5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    transform: "translate(3.000000, 9.500000) rotate(-270.000000) translate(-3.000000, -9.500000) ",
    x: "2",
    y: "7",
    width: "2",
    height: "5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    transform: "translate(4.500000, 4.500000) rotate(135.000000) translate(-4.500000, -4.500000) ",
    x: "3.5",
    y: "2",
    width: "2",
    height: "5",
    rx: "1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.181981, 12.681981) rotate(-315.000000) translate(-13.181981, -12.681981) translate(7.681981, 3.181981)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "7.10542736e-15",
    y: "-1.0658141e-14",
    width: "2",
    height: "5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: "7.10542736e-15",
    y: "14",
    width: "2",
    height: "5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(8.000000, 9.500000) rotate(-270.000000) translate(-8.000000, -9.500000) ",
    x: "7",
    y: "7",
    width: "2",
    height: "5",
    rx: "1"
  })))));
});